import palette from "src/theme/palette";

export const RENEWAL_WARNING_CHIP_STYLE = {
  backgroundColorPath: ["warning", "200"],
  textColorPath: ["warning", "700"]
};

export const ACTIVE_CHIP_STYLE = {
  backgroundColorPath: ["success", "200"],
  textColorPath: ["success", "600"]
};

export const RENEWAL_WARNING_DAYS_THRESHOLD = 90;

export const GO_LIVE_WARNING_DAYS_THRESHOLD = 90;

export const TEAM_ROLES = {
  csm: "Customer Success Manager",
  solutionArchitect: "Solutions Architect"
};

export const PRODUCTS_TABLE_COLUMNS = [
  { field: "name", headerName: "Product" }
];

export const CHANNEL_META = {
  voice_inbound: {
    label: "Voice inbound",
    color: palette.success[500],
    tooltip: "All engaged calls"
  },
  chat: {
    label: "Chat",
    color: palette.info[600],
    tooltip: "All engaged conversations"
  },
  voice_outbound: {
    label: "Outbound",
    color: palette.secondary[400],
    tooltip: "All answered calls and answering machine"
  }
};

export const USAGE_BAR_COLORS = {
  track: palette.system[300]
};

export const USAGE_BAR_MIN_SEGMENT_PX = 18;

export const GO_LIVE_BANNER_TEXT = "Go-live date is not set yet, ";
export const GO_LIVE_BANNER_LINK = "set up in Salesforce";
export const GO_LIVE_SET_UP_LINK = "Set up";

export const buildSalesforceAssetsUrl = (salesforceAccountId) =>
  `https://airbudtechnologies.lightning.force.com/lightning/r/Account/${salesforceAccountId}/related/Assets/view`;

export const ALL_CHANNELS_USAGE_LABEL = "All channels usage";

export const QUOTA_NOT_STARTED_SUBTITLE = "Once the term will be active we will track the subscription activity here.";

export const UNLIMITED_LIMIT_LABEL = "Unlimited";
export const UNLIMITED_PLAN_SUBTITLE = "Account allowed unlimited interactions through their plan";
export const buildPlanSubtitle = (limit) => `Account allowed ${limit.toLocaleString()} interactions through their plan`;
